<template>
    <div class="gym-alerts">
        <div class="panel-section-title">{{ $t('company.gym_alerts') }}</div>

        <div class="alert-card risk">
            <div class="alert-card-icon">
                <v-icon size="18">mdi-alert-outline</v-icon>
            </div>
            <div class="alert-card-body">
                <div class="alert-card-value">{{ riskLabel }}</div>
                <div class="alert-card-label">{{ $t('company.at_risk_of_leaving') }}</div>
            </div>
        </div>

        <div class="alert-card new">
            <div class="alert-card-icon">
                <v-icon size="18">mdi-account-plus-outline</v-icon>
            </div>
            <div class="alert-card-body">
                <div class="alert-card-value">{{ newLabel }}</div>
                <div class="alert-card-label">{{ $t('company.new_last_days', { n: 30 }) }}</div>
            </div>
        </div>

        <div v-if="bestCoach" class="alert-card best">
            <div class="alert-card-icon">
                <v-icon size="18">mdi-star-outline</v-icon>
            </div>
            <div class="alert-card-body">
                <div class="alert-card-value">{{ bestCoach.name }}</div>
                <div class="alert-card-label">
                    {{ $t('company.best_coach_month') }} · {{ $t('company.avg_adherence', { n: bestCoach.adherence }) }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "GymAlerts",
    props: {
        stats: {
            type: Object,
            default: null,
        },
    },
    computed: {
        totals(vm = this) {
            return vm.stats?.totals || null
        },
        riskLabel(vm = this) {
            const value = vm.totals?.riskCount
            if (typeof value !== 'number') return '—'
            return vm.$tc('company.students_count', value, { n: value })
        },
        newLabel(vm = this) {
            const value = vm.totals?.newStudents30d
            if (typeof value !== 'number') return '—'
            return vm.$tc('company.students_count', value, { n: value })
        },
        bestCoach(vm = this) {
            const id = vm.totals?.bestCoachId
            if (!id) return null
            const coach = vm.stats?.coaches?.[id]
            if (!coach) return null
            return { name: coach.name, adherence: vm.totals.bestAdherence }
        },
    },
}
</script>

<style scoped>
.gym-alerts {
    padding: 16px 20px calc(16px + var(--safe-area-inset-bottom, 0px));
}

.panel-section-title {
    font-size: 11px;
    font-weight: 700;
    color: var(--v-txtMuted-base);
    text-transform: uppercase;
    letter-spacing: 0.06em;
    margin-bottom: 10px;
}

.alert-card {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    border-radius: 10px;
    border: 1px solid var(--v-outline-base);
    background: var(--v-surface2-base);
    margin-bottom: 8px;
}

.alert-card:last-child {
    margin-bottom: 0;
}

.alert-card-icon {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.alert-card.risk .alert-card-icon {
    background: rgba(232, 92, 92, 0.12);
    color: var(--v-error-base);
}

.alert-card.new .alert-card-icon {
    background: rgba(102, 204, 204, 0.14);
    color: var(--v-secondary-base);
}

.alert-card.best .alert-card-icon {
    background: rgba(204, 255, 51, 0.12);
    color: var(--v-primary-base);
}

.theme--light .alert-card.best .alert-card-icon {
    background: rgba(51, 153, 153, 0.12);
    color: var(--v-accent-base);
}

.alert-card-body {
    min-width: 0;
}

.alert-card-value {
    font-size: 13px;
    font-weight: 700;
    color: var(--v-txtPrimary-base);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.alert-card-label {
    font-size: 10px;
    color: var(--v-txtSecondary-base);
    margin-top: 1px;
}
</style>
